/* Shrink-to-fit for product card headings and price rows.
 *
 * One copy. This lived three times, byte-identical, in product-collection-grid,
 * how-to-use-product and product-card.
 *
 * CALL SITES PUSH TO A QUEUE, they do not call register() directly:
 *
 *   (window.IEShrinkQueue = window.IEShrinkQueue || []).push(function () { ... });
 *
 * That makes load order irrelevant, so this file can be `defer`red without a
 * section's inline script racing it. A parser-blocking <script src> would fix the
 * order too and trips theme-check's ParserBlockingScript rule.
 *
 * register() runs the callback on ready, on debounced resize AND on fonts.ready. That last one is the whole reason this
 * was worth extracting -- all three copies measured against FALLBACK font metrics
 * and never re-ran once the real face swapped in, which is the one event that
 * invalidates a scrollWidth-vs-clientWidth comparison.
 */
(function () {
  if (window.IEShrink) return;

  /* The inline-style reset is load-bearing: without it a size set at a narrower
     width pins scrollWidth/clientWidth and the text can never grow back. */
  function fit(el) {
    if (!el) return;
    el.style.fontSize = '';
    var baseSize = parseFloat(getComputedStyle(el).fontSize);
    if (el.scrollWidth <= el.clientWidth) return;
    var scale = el.clientWidth / el.scrollWidth;
    el.style.fontSize = (baseSize * scale) + 'px';
  }

  /* Measures the ROW, not the price: the price is flex-shrink:0, so its
     scrollWidth always equals its clientWidth and it can never report overflow.

     Selects by class SUBSTRING, scoped to the row, so one copy serves both the
     .cc__ and .pc__ naming without taking a prefix argument. */
  function fitSubRow(subRow) {
    if (!subRow) return;
    var subtitle = subRow.querySelector('[class*="__subtitle"]');
    var sym      = subRow.querySelector('[class*="price-sym"]');
    var whole    = subRow.querySelector('[class*="price-whole"]');
    var frac     = subRow.querySelector('[class*="price-frac"]');
    var all      = [subtitle, sym, whole, frac];
    var boxed    = [sym, frac];

    all.forEach(function (el) { if (el) el.style.fontSize = ''; });
    boxed.forEach(function (el) {
      if (!el) return;
      el.style.height = '';
      el.style.width  = '';
    });

    if (subRow.scrollWidth <= subRow.clientWidth) return;
    var scale = subRow.clientWidth / subRow.scrollWidth;

    all.forEach(function (el) {
      if (!el) return;
      el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * scale) + 'px';
    });
    /* sym/frac carry explicit box sizes; scale those too or the shrunk glyphs sit
       wrong inside them. */
    boxed.forEach(function (el) {
      if (!el) return;
      var cs = getComputedStyle(el);
      el.style.height = (parseFloat(cs.height) * scale) + 'px';
      el.style.width  = (parseFloat(cs.width) * scale) + 'px';
    });
  }

  var callbacks = [];
  function runAll() {
    callbacks.forEach(function (fn) { try { fn(); } catch (e) {} });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(runAll, 100);
  });

  function register(fn) {
    callbacks.push(fn);
    /* readyState check, not a bare listener: the Theme Editor injects a section
       long after DOMContentLoaded has fired, and a listener alone never runs. */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fn);
    }
  }

  window.IEShrink = { fit: fit, fitSubRow: fitSubRow, register: register };

  /* Drain anything queued before this file arrived, then replace the queue with a
     shim so a LATER push (a Theme Editor section injection) registers immediately
     instead of sitting in an array nobody reads again. */
  var queued = window.IEShrinkQueue || [];
  window.IEShrinkQueue = { push: register };
  queued.forEach(register);
}());
